import request from "@/utils/request";
const apiPath = "/meet/meetingSignUpTransportation";
import { downloadBlob } from "@/utils/download";

const meetingSignUpTransportationApi = {
  /**
   * 下载Excel模板 · 交通方式的
   */
  downloadExcelTemplate(query) {
    return request
      .get(`${apiPath}/teev2/downloadExcelTemplate`, {
        responseType: "blob",
        params: query
      })
      .then(res => downloadBlob(res, "交通方式模版.xlsx"));
  },
  /**
   * 导入Excel · 交通方式的
   */
  import(data) {
    return request.post(`${apiPath}/teev2/import`, data);
  },
  /**
   * 获取交通方式列表（teev2接口）
   */
  fetchListTeev2(query) {
    return request.get(`${apiPath}/teev2/list`, { params: query });
  },
  /**
   * 保存交通方式（teev2接口）
   */
  saveTeev2(data) {
    return request.post(`${apiPath}/teev2/save`, data);
  },
  /**
   * 删除交通方式
   */
  deleteTeev2(id) {
    return request.delete(`${apiPath}/teev2/${id}`);
  }
};

export default meetingSignUpTransportationApi;

